module.exports = __webpack_public_path__ + "static/media/shape0_5.b54ac9bb.obj";